function mapCategoryPath({ key, path, children }) {
  if (Array.isArray(children)) {
    return children.map(({ key, path }) => {
      return { key, path }
    })
  } else {
    return [ { key, path } ]
  }
}

export function mapCategoryPaths(categories) {
  return categories.reduce((acc, { key, path, children }) => {
    const items = mapCategoryPath({ key, path, children })
    return items.reduce((acc, { key, path }) => {
      acc[key] = path
      return acc
    }, acc)
  }, {})
}